export enum DermaConsultationAssetDropzoneExtraActions {
    uploadFromApp = 'uploadFromApp',
}
